"use client";

import { c as _c } from "react/compiler-runtime";
import type React from "react";
import { useCheckUserExists } from "@/hooks/use-check-user-exists";
interface CheckUserExistsPollingProviderProps {
  children: React.ReactNode;
}
export function CheckUserExistsPollingProvider(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  useCheckUserExists();
  let t1;
  if ($[0] !== children) {
    t1 = <>{children}</>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}